// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleCalendar_workspace__oOzDh {
  --calendar-border: #dbe2ea;
  --calendar-surface: #ffffff;
  --calendar-muted: #667085;
  --calendar-background: #f5f7fb;
  --calendar-accent: #2563eb;
  --calendar-accent-soft: #eaf2ff;
  width: 100%;
  min-width: 0;
  margin: 1.25rem 0 2rem;
  overflow: hidden;
  color: #243142;
  background: var(--calendar-surface);
  border: 1px solid var(--calendar-border);
  border-radius: 1.1rem;
  box-shadow: 0 1rem 3rem rgba(35, 49, 66, 0.09);
}

.ScheduleCalendar_workspaceHeader__bELDO {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.35rem 1.5rem 1rem;
  background:
    radial-gradient(circle at 100% 0, rgba(37, 99, 235, 0.11), transparent 30%),
    linear-gradient(135deg, #ffffff 0%, #fbfcff 100%);
}

.ScheduleCalendar_workspaceHeader__bELDO h1 {
  margin: 0.15rem 0 0.25rem;
  font-family: var(--title);
  font-size: clamp(1.65rem, 2.4vw, 2.35rem);
  line-height: 1.1;
}

.ScheduleCalendar_workspaceHeader__bELDO p {
  max-width: 52rem;
  margin: 0;
  color: var(--calendar-muted);
  text-align: left;
}

.ScheduleCalendar_eyebrow__uYDMg,
.ScheduleCalendar_detailEyebrow__CSXj2 {
  color: var(--calendar-accent);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.ScheduleCalendar_readOnlyBadge__MRWSM,
.ScheduleCalendar_statusBadge__i4SvY {
  display: inline-flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0.4rem 0.7rem;
  color: #344054;
  font-size: 0.76rem;
  font-weight: 700;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--calendar-border);
  border-radius: 999px;
}

.ScheduleCalendar_toolbar__53MBq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 4.1rem;
  padding: 0.75rem 1rem;
  background: #ffffff;
  border-top: 1px solid #eef1f5;
  border-bottom: 1px solid var(--calendar-border);
}

.ScheduleCalendar_toolbarNavigation__TlPVF,
.ScheduleCalendar_viewSwitcher__Vng6T {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.ScheduleCalendar_primaryCommand__JdF3O,
.ScheduleCalendar_iconCommand__qk52l,
.ScheduleCalendar_viewButton__hDo-L,
.ScheduleCalendar_activeView__hO5fC,
.ScheduleCalendar_inlineError__bkAn- button,
.ScheduleCalendar_stateMessage__9kgoo button {
  min-height: 2.35rem;
  padding: 0 0.85rem;
  color: #344054;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 700;
  background: #ffffff;
  border: 1px solid var(--calendar-border);
  border-radius: 0.55rem;
  cursor: pointer;
  transition: border-color 140ms ease, background 140ms ease, transform 140ms ease;
}

.ScheduleCalendar_primaryCommand__JdF3O:hover,
.ScheduleCalendar_iconCommand__qk52l:hover,
.ScheduleCalendar_viewButton__hDo-L:hover,
.ScheduleCalendar_inlineError__bkAn- button:hover,
.ScheduleCalendar_stateMessage__9kgoo button:hover {
  background: #f8fafc;
  border-color: #98a2b3;
}

.ScheduleCalendar_primaryCommand__JdF3O:active,
.ScheduleCalendar_iconCommand__qk52l:active,
.ScheduleCalendar_viewButton__hDo-L:active,
.ScheduleCalendar_activeView__hO5fC:active {
  transform: translateY(1px);
}

.ScheduleCalendar_primaryCommand__JdF3O {
  color: #ffffff;
  background: #243142;
  border-color: #243142;
}

.ScheduleCalendar_primaryCommand__JdF3O:hover {
  color: #ffffff;
  background: #101828;
  border-color: #101828;
}

.ScheduleCalendar_iconCommand__qk52l {
  width: 2.35rem;
  padding: 0;
  font-size: 1.45rem;
  line-height: 1;
}

.ScheduleCalendar_periodTitle__VEclP {
  margin: 0 0 0 0.45rem;
  font-family: var(--title);
  font-size: 1.16rem;
  font-weight: 700;
  white-space: nowrap;
}

.ScheduleCalendar_viewSwitcher__Vng6T {
  padding: 0.22rem;
  background: #f2f4f7;
  border-radius: 0.72rem;
}

.ScheduleCalendar_viewButton__hDo-L,
.ScheduleCalendar_activeView__hO5fC {
  min-height: 2rem;
  border-color: transparent;
  background: transparent;
}

.ScheduleCalendar_activeView__hO5fC {
  color: #1d4ed8;
  background: #ffffff;
  border-color: #dbe7ff;
  box-shadow: 0 0.18rem 0.55rem rgba(16, 24, 40, 0.08);
}

.ScheduleCalendar_workspaceBody__lDhHL {
  position: relative;
  display: grid;
  grid-template-columns: 17rem minmax(0, 1fr);
  align-items: stretch;
  min-height: 49rem;
  background: var(--calendar-background);
}

.ScheduleCalendar_sidebar__VLvZj {
  min-width: 0;
  padding: 1rem;
  background: #fbfcfe;
  border-right: 1px solid var(--calendar-border);
}

.ScheduleCalendar_miniCalendar__lO58e,
.ScheduleCalendar_scheduleSelector__jEFEA {
  padding: 0.85rem;
  background: #ffffff;
  border: 1px solid #e4e9f0;
  border-radius: 0.9rem;
}

.ScheduleCalendar_scheduleSelector__jEFEA {
  margin-top: 0.85rem;
}

.ScheduleCalendar_miniCalendarHeader__oOFUi,
.ScheduleCalendar_scheduleSelectorHeader__9bSVR {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.ScheduleCalendar_miniCalendarHeader__oOFUi strong {
  font-family: var(--title);
  font-size: 0.94rem;
  text-transform: capitalize;
}

.ScheduleCalendar_miniCalendarHeader__oOFUi div {
  display: flex;
  gap: 0.15rem;
}

.ScheduleCalendar_miniCalendarHeader__oOFUi button,
.ScheduleCalendar_scheduleSelectorHeader__9bSVR button,
.ScheduleCalendar_appointmentPanelHeader__NoNib button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.8rem;
  min-height: 1.8rem;
  padding: 0;
  color: #475467;
  font: inherit;
  background: transparent;
  border: 0;
  border-radius: 0.4rem;
  cursor: pointer;
}

.ScheduleCalendar_miniCalendarHeader__oOFUi button:hover,
.ScheduleCalendar_scheduleSelectorHeader__9bSVR button:hover,
.ScheduleCalendar_appointmentPanelHeader__NoNib button:hover {
  color: #1d4ed8;
  background: #eff4ff;
}

.ScheduleCalendar_miniCalendarGrid__nxyvA {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.16rem;
  margin-top: 0.7rem;
}

.ScheduleCalendar_miniWeekDay__X0lZ7,
.ScheduleCalendar_miniDay__ORpDA {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  font-size: 0.75rem;
  text-align: center;
}

.ScheduleCalendar_miniWeekDay__X0lZ7 {
  color: #98a2b3;
  font-weight: 800;
  text-transform: uppercase;
}

.ScheduleCalendar_miniDay__ORpDA {
  color: #344054;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 50%;
  cursor: pointer;
}

.ScheduleCalendar_miniDay__ORpDA:hover {
  background: #f2f4f7;
}

.ScheduleCalendar_miniDayOutside__zWvs6 {
  color: #b7bfca;
}

.ScheduleCalendar_miniDayToday__U7f04 {
  color: #1d4ed8;
  font-weight: 800;
  border-color: #93b4ff;
}

.ScheduleCalendar_miniDaySelected__y9uc\\+ {
  color: #ffffff;
  font-weight: 800;
  background: var(--calendar-accent);
  border-color: var(--calendar-accent);
}

.ScheduleCalendar_miniDaySelected__y9uc\\+:hover {
  background: #1d4ed8;
}

.ScheduleCalendar_scheduleSelectorHeader__9bSVR h3 {
  margin: 0;
  font-family: var(--title);
  font-size: 1rem;
}

.ScheduleCalendar_scheduleSelectorHeader__9bSVR button {
  width: auto;
  padding: 0 0.35rem;
  color: #2563eb;
  font-size: 0.75rem;
  font-weight: 700;
}

.ScheduleCalendar_scheduleList__P7NRv {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-top: 0.65rem;
}

.ScheduleCalendar_scheduleOption__W9Uws {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0.55rem 0.45rem;
  border-radius: 0.55rem;
  cursor: pointer;
}

.ScheduleCalendar_scheduleOption__W9Uws:hover {
  background: #f6f8fb;
}

.ScheduleCalendar_scheduleOption__W9Uws input {
  width: 1rem;
  height: 1rem;
  margin: 0;
  accent-color: var(--calendar-accent);
}

.ScheduleCalendar_scheduleDot__yjyjl {
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 50%;
  box-shadow: 0 0 0 0.18rem rgba(255, 255, 255, 0.85);
}

.ScheduleCalendar_scheduleOptionText__07wO9 {
  min-width: 0;
}

.ScheduleCalendar_scheduleOptionText__07wO9 strong,
.ScheduleCalendar_scheduleOptionText__07wO9 small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ScheduleCalendar_scheduleOptionText__07wO9 strong {
  color: #344054;
  font-size: 0.84rem;
}

.ScheduleCalendar_scheduleOptionText__07wO9 small {
  margin-top: 0.08rem;
  color: var(--calendar-muted);
  font-size: 0.71rem;
}

.ScheduleCalendar_calendarSurface__9RF-i {
  position: relative;
  min-width: 0;
  min-height: 49rem;
  overflow: hidden;
  background: #ffffff;
}

.ScheduleCalendar_gridWrapper__zRQAE {
  position: relative;
  height: 100%;
  min-height: 49rem;
}

.ScheduleCalendar_timeGridViewport__tBidz {
  width: 100%;
  max-height: 49rem;
  overflow: auto;
  background: #ffffff;
}

.ScheduleCalendar_timeGrid__WV4NT {
  display: grid;
  min-width: 48rem;
  isolation: isolate;
}

.ScheduleCalendar_timeGridCorner__wsP0R,
.ScheduleCalendar_dayHeader__XEN48 {
  position: sticky;
  top: 0;
  z-index: 5;
  min-height: 4.35rem;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid var(--calendar-border);
  -webkit-backdrop-filter: blur(0.6rem);
          backdrop-filter: blur(0.6rem);
}

.ScheduleCalendar_timeGridCorner__wsP0R {
  left: 0;
  z-index: 7;
}

.ScheduleCalendar_dayHeader__XEN48 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.7rem 0.35rem;
  color: #667085;
  border-left: 1px solid #edf0f4;
}

.ScheduleCalendar_dayHeader__XEN48 span {
  font-size: 0.77rem;
  font-weight: 800;
  text-transform: capitalize;
}

.ScheduleCalendar_dayHeader__XEN48 strong {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  color: #344054;
  font-size: 1rem;
  border-radius: 50%;
}

.ScheduleCalendar_dayHeaderToday__\\+7OQ3 strong {
  color: #ffffff;
  background: var(--calendar-accent);
}

.ScheduleCalendar_hourLabels__jP9d- {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #ffffff;
  border-right: 1px solid var(--calendar-border);
}

.ScheduleCalendar_hourLabels__jP9d- span {
  position: absolute;
  right: 0.55rem;
  color: #98a2b3;
  font-size: 0.7rem;
  transform: translateY(-0.52em);
}

.ScheduleCalendar_dayColumn__P-jO7 {
  position: relative;
  min-width: 0;
  background:
    linear-gradient(to bottom, transparent 50%, rgba(238, 241, 245, 0.55) 50%) 0 0 / 100% 32px,
    #ffffff;
  border-left: 1px solid #edf0f4;
}

.ScheduleCalendar_hourLine__UGeAF {
  position: absolute;
  right: 0;
  left: 0;
  height: 1px;
  background: #e7ebf0;
  pointer-events: none;
}

.ScheduleCalendar_currentTimeLine__qo1Cd {
  position: absolute;
  right: 0;
  left: 0;
  z-index: 3;
  height: 2px;
  background: #e40032;
  pointer-events: none;
}

.ScheduleCalendar_currentTimeLine__qo1Cd::before {
  position: absolute;
  top: 50%;
  left: -0.28rem;
  width: 0.56rem;
  height: 0.56rem;
  background: #e40032;
  border-radius: 50%;
  content: "";
  transform: translateY(-50%);
}

.ScheduleCalendar_timeEvent__a3D3f {
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 1.75rem;
  padding: 0.34rem 0.42rem 0.34rem 0.55rem;
  overflow: hidden;
  color: #1f2937;
  text-align: left;
  background: color-mix(in srgb, var(--event-color) 12%, white);
  border: 0;
  border-left: 0.24rem solid var(--event-color);
  border-radius: 0.42rem;
  box-shadow: 0 0.15rem 0.35rem rgba(16, 24, 40, 0.09);
  cursor: pointer;
}

.ScheduleCalendar_timeEvent__a3D3f:hover,
.ScheduleCalendar_timeEvent__a3D3f:focus-visible {
  z-index: 4;
  outline: 2px solid color-mix(in srgb, var(--event-color) 40%, white);
  box-shadow: 0 0.35rem 0.85rem rgba(16, 24, 40, 0.16);
}

.ScheduleCalendar_timeEvent__a3D3f strong,
.ScheduleCalendar_timeEvent__a3D3f span,
.ScheduleCalendar_timeEvent__a3D3f small {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ScheduleCalendar_timeEvent__a3D3f strong {
  font-size: 0.78rem;
  line-height: 1.22;
}

.ScheduleCalendar_timeEvent__a3D3f span,
.ScheduleCalendar_timeEvent__a3D3f small {
  margin-top: 0.1rem;
  color: #536071;
  font-size: 0.66rem;
}

.ScheduleCalendar_monthGrid__dY4SB {
  display: grid;
  grid-template-columns: repeat(7, minmax(7rem, 1fr));
  min-width: 55rem;
  min-height: 49rem;
  overflow: auto;
  background: #ffffff;
}

.ScheduleCalendar_monthWeekDay__kJA96 {
  position: sticky;
  top: 0;
  z-index: 3;
  padding: 0.75rem;
  color: #667085;
  font-size: 0.74rem;
  font-weight: 800;
  text-transform: capitalize;
  background: rgba(255, 255, 255, 0.97);
  border-bottom: 1px solid var(--calendar-border);
  border-left: 1px solid #edf0f4;
}

.ScheduleCalendar_monthDay__NDqJs {
  min-height: 7.4rem;
  padding: 0.45rem;
  background: #ffffff;
  border-bottom: 1px solid #edf0f4;
  border-left: 1px solid #edf0f4;
}

.ScheduleCalendar_monthDayOutside__F57fX {
  background: #fafbfd;
}

.ScheduleCalendar_monthDayOutside__F57fX .ScheduleCalendar_monthDayNumber__MCUf4 {
  color: #b3bbc7;
}

.ScheduleCalendar_monthDayToday__AnOry {
  background: #f7faff;
  box-shadow: inset 0 0 0 1px #bdd2ff;
}

.ScheduleCalendar_monthDayNumber__MCUf4 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  margin: 0 0 0.25rem auto;
  color: #344054;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}

.ScheduleCalendar_monthDayNumber__MCUf4:hover,
.ScheduleCalendar_monthDayToday__AnOry .ScheduleCalendar_monthDayNumber__MCUf4 {
  color: #ffffff;
  background: var(--calendar-accent);
}

.ScheduleCalendar_monthEvents__1gAdz {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.ScheduleCalendar_monthEvent__lxF7s {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.35rem;
  align-items: center;
  width: 100%;
  padding: 0.24rem 0.35rem;
  color: #344054;
  text-align: left;
  background: color-mix(in srgb, var(--event-color) 10%, white);
  border: 0;
  border-left: 0.18rem solid var(--event-color);
  border-radius: 0.3rem;
  cursor: pointer;
}

.ScheduleCalendar_monthEvent__lxF7s:hover {
  background: color-mix(in srgb, var(--event-color) 18%, white);
}

.ScheduleCalendar_monthEvent__lxF7s span {
  color: #667085;
  font-size: 0.64rem;
}

.ScheduleCalendar_monthEvent__lxF7s strong {
  overflow: hidden;
  font-size: 0.69rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ScheduleCalendar_moreEvents__bT\\+KX {
  padding-left: 0.35rem;
  color: #2563eb;
  font-size: 0.7rem;
  font-weight: 700;
}

.ScheduleCalendar_inlineError__bkAn- {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0.75rem;
  padding: 0.7rem 0.85rem;
  color: #912018;
  background: #fff2f0;
  border: 1px solid #f7c3bd;
  border-radius: 0.65rem;
}

.ScheduleCalendar_inlineError__bkAn- button {
  min-height: 1.9rem;
  color: #912018;
  border-color: #eaa49c;
}

.ScheduleCalendar_stateMessage__9kgoo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 34rem;
  padding: 2rem;
  color: #475467;
  text-align: center;
}

.ScheduleCalendar_stateMessage__9kgoo h3 {
  margin: 0.8rem 0 0.25rem;
  color: #243142;
  font-family: var(--title);
  font-size: 1.25rem;
}

.ScheduleCalendar_stateMessage__9kgoo p {
  max-width: 30rem;
  margin: 0 0 1rem;
  color: #667085;
  text-align: center;
}

.ScheduleCalendar_stateIcon__bKDj9 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  color: #2563eb;
  font-size: 1.65rem;
  background: #eaf2ff;
  border-radius: 1rem;
}

.ScheduleCalendar_loadingOverlay__klHSi {
  position: absolute;
  inset: 0;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  color: #344054;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.72);
  -webkit-backdrop-filter: blur(0.14rem);
          backdrop-filter: blur(0.14rem);
}

.ScheduleCalendar_spinner__96gQG {
  width: 1.3rem;
  height: 1.3rem;
  border: 0.16rem solid #d9e4fb;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: ScheduleCalendar_calendarSpin__FghWp 700ms linear infinite;
}

.ScheduleCalendar_emptyCalendarNotice__4dGdZ {
  position: absolute;
  top: 5.2rem;
  left: 50%;
  z-index: 3;
  padding: 0.45rem 0.75rem;
  color: #667085;
  font-size: 0.78rem;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e4e9f0;
  border-radius: 999px;
  box-shadow: 0 0.2rem 0.7rem rgba(16, 24, 40, 0.07);
  transform: translateX(-50%);
}

.ScheduleCalendar_appointmentPanel__e-olh {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 12;
  width: min(23rem, 94%);
  padding: 1.2rem;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.98);
  border-left: 1px solid var(--calendar-border);
  box-shadow: -1rem 0 2.5rem rgba(16, 24, 40, 0.13);
  -webkit-backdrop-filter: blur(0.75rem);
          backdrop-filter: blur(0.75rem);
}

.ScheduleCalendar_appointmentPanelHeader__NoNib {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #edf0f4;
}

.ScheduleCalendar_appointmentPanelHeader__NoNib h3 {
  margin: 0.25rem 0 0;
  color: #243142;
  font-family: var(--title);
  font-size: 1.25rem;
}

.ScheduleCalendar_appointmentPanelHeader__NoNib button {
  font-size: 1.35rem;
}

.ScheduleCalendar_statusBadge__i4SvY {
  margin-top: 0.8rem;
  color: #1d4ed8;
  background: #eff4ff;
  border-color: #c7d8ff;
}

.ScheduleCalendar_detailList__CY2dK {
  margin: 0.4rem 0 0;
}

.ScheduleCalendar_detailList__CY2dK > div {
  padding: 0.85rem 0;
  border-bottom: 1px solid #edf0f4;
}

.ScheduleCalendar_detailList__CY2dK dt {
  margin-bottom: 0.28rem;
  color: #667085;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.045em;
  text-transform: uppercase;
}

.ScheduleCalendar_detailList__CY2dK dd {
  margin: 0;
  color: #344054;
  font-size: 0.87rem;
  line-height: 1.45;
}

.ScheduleCalendar_detailSchedules__lwnvw {
  display: flex;
  flex-direction: column;
  gap: 0.38rem;
}

.ScheduleCalendar_detailSchedules__lwnvw span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ScheduleCalendar_detailSchedules__lwnvw i {
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 50%;
}

@keyframes ScheduleCalendar_calendarSpin__FghWp {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 1050px) {
  .ScheduleCalendar_workspaceBody__lDhHL {
    grid-template-columns: 14rem minmax(0, 1fr);
  }

  .ScheduleCalendar_sidebar__VLvZj {
    padding: 0.75rem;
  }

  .ScheduleCalendar_periodTitle__VEclP {
    font-size: 1rem;
  }
}

@media (max-width: 820px) {
  .ScheduleCalendar_workspaceHeader__bELDO,
  .ScheduleCalendar_toolbar__53MBq {
    align-items: stretch;
    flex-direction: column;
  }

  .ScheduleCalendar_toolbarNavigation__TlPVF {
    flex-wrap: wrap;
  }

  .ScheduleCalendar_periodTitle__VEclP {
    width: 100%;
    margin: 0.35rem 0 0;
  }

  .ScheduleCalendar_viewSwitcher__Vng6T {
    align-self: flex-start;
  }

  .ScheduleCalendar_workspaceBody__lDhHL {
    display: block;
  }

  .ScheduleCalendar_sidebar__VLvZj {
    display: grid;
    grid-template-columns: minmax(14rem, 1fr) minmax(14rem, 1fr);
    gap: 0.75rem;
    border-right: 0;
    border-bottom: 1px solid var(--calendar-border);
  }

  .ScheduleCalendar_scheduleSelector__jEFEA {
    margin-top: 0;
  }

  .ScheduleCalendar_calendarSurface__9RF-i,
  .ScheduleCalendar_gridWrapper__zRQAE {
    min-height: 42rem;
  }
}

@media (max-width: 560px) {
  .ScheduleCalendar_workspace__oOzDh {
    border-right: 0;
    border-left: 0;
    border-radius: 0;
  }

  .ScheduleCalendar_workspaceHeader__bELDO {
    padding: 1rem;
  }

  .ScheduleCalendar_readOnlyBadge__MRWSM {
    align-self: flex-start;
  }

  .ScheduleCalendar_sidebar__VLvZj {
    display: block;
  }

  .ScheduleCalendar_scheduleSelector__jEFEA {
    margin-top: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScheduleCalendar/ScheduleCalendar.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B;;qDAEmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;;;EAME,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,eAAe;EACf,gFAAgF;AAClF;;AAEA;;;;;EAKE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,qCAAqC;EACrC,+CAA+C;EAC/C,qCAA6B;UAA7B,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ;;WAES;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,SAAS;EACT,6CAA6C;EAC7C,sBAAsB;EACtB,oDAAoD;EACpD,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,oEAAoE;EACpE,oDAAoD;AACtD;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,SAAS;EACT,6CAA6C;EAC7C,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,sCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,qEAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,oBAAoB;EACpB,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,iDAAiD;EACjD,sCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,YAAY;IACZ,eAAe;IACf,+CAA+C;EACjD;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".workspace {\n  --calendar-border: #dbe2ea;\n  --calendar-surface: #ffffff;\n  --calendar-muted: #667085;\n  --calendar-background: #f5f7fb;\n  --calendar-accent: #2563eb;\n  --calendar-accent-soft: #eaf2ff;\n  width: 100%;\n  min-width: 0;\n  margin: 1.25rem 0 2rem;\n  overflow: hidden;\n  color: #243142;\n  background: var(--calendar-surface);\n  border: 1px solid var(--calendar-border);\n  border-radius: 1.1rem;\n  box-shadow: 0 1rem 3rem rgba(35, 49, 66, 0.09);\n}\n\n.workspaceHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.35rem 1.5rem 1rem;\n  background:\n    radial-gradient(circle at 100% 0, rgba(37, 99, 235, 0.11), transparent 30%),\n    linear-gradient(135deg, #ffffff 0%, #fbfcff 100%);\n}\n\n.workspaceHeader h1 {\n  margin: 0.15rem 0 0.25rem;\n  font-family: var(--title);\n  font-size: clamp(1.65rem, 2.4vw, 2.35rem);\n  line-height: 1.1;\n}\n\n.workspaceHeader p {\n  max-width: 52rem;\n  margin: 0;\n  color: var(--calendar-muted);\n  text-align: left;\n}\n\n.eyebrow,\n.detailEyebrow {\n  color: var(--calendar-accent);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n}\n\n.readOnlyBadge,\n.statusBadge {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  padding: 0.4rem 0.7rem;\n  color: #344054;\n  font-size: 0.76rem;\n  font-weight: 700;\n  white-space: nowrap;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid var(--calendar-border);\n  border-radius: 999px;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  min-height: 4.1rem;\n  padding: 0.75rem 1rem;\n  background: #ffffff;\n  border-top: 1px solid #eef1f5;\n  border-bottom: 1px solid var(--calendar-border);\n}\n\n.toolbarNavigation,\n.viewSwitcher {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.primaryCommand,\n.iconCommand,\n.viewButton,\n.activeView,\n.inlineError button,\n.stateMessage button {\n  min-height: 2.35rem;\n  padding: 0 0.85rem;\n  color: #344054;\n  font: inherit;\n  font-size: 0.88rem;\n  font-weight: 700;\n  background: #ffffff;\n  border: 1px solid var(--calendar-border);\n  border-radius: 0.55rem;\n  cursor: pointer;\n  transition: border-color 140ms ease, background 140ms ease, transform 140ms ease;\n}\n\n.primaryCommand:hover,\n.iconCommand:hover,\n.viewButton:hover,\n.inlineError button:hover,\n.stateMessage button:hover {\n  background: #f8fafc;\n  border-color: #98a2b3;\n}\n\n.primaryCommand:active,\n.iconCommand:active,\n.viewButton:active,\n.activeView:active {\n  transform: translateY(1px);\n}\n\n.primaryCommand {\n  color: #ffffff;\n  background: #243142;\n  border-color: #243142;\n}\n\n.primaryCommand:hover {\n  color: #ffffff;\n  background: #101828;\n  border-color: #101828;\n}\n\n.iconCommand {\n  width: 2.35rem;\n  padding: 0;\n  font-size: 1.45rem;\n  line-height: 1;\n}\n\n.periodTitle {\n  margin: 0 0 0 0.45rem;\n  font-family: var(--title);\n  font-size: 1.16rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.viewSwitcher {\n  padding: 0.22rem;\n  background: #f2f4f7;\n  border-radius: 0.72rem;\n}\n\n.viewButton,\n.activeView {\n  min-height: 2rem;\n  border-color: transparent;\n  background: transparent;\n}\n\n.activeView {\n  color: #1d4ed8;\n  background: #ffffff;\n  border-color: #dbe7ff;\n  box-shadow: 0 0.18rem 0.55rem rgba(16, 24, 40, 0.08);\n}\n\n.workspaceBody {\n  position: relative;\n  display: grid;\n  grid-template-columns: 17rem minmax(0, 1fr);\n  align-items: stretch;\n  min-height: 49rem;\n  background: var(--calendar-background);\n}\n\n.sidebar {\n  min-width: 0;\n  padding: 1rem;\n  background: #fbfcfe;\n  border-right: 1px solid var(--calendar-border);\n}\n\n.miniCalendar,\n.scheduleSelector {\n  padding: 0.85rem;\n  background: #ffffff;\n  border: 1px solid #e4e9f0;\n  border-radius: 0.9rem;\n}\n\n.scheduleSelector {\n  margin-top: 0.85rem;\n}\n\n.miniCalendarHeader,\n.scheduleSelectorHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.miniCalendarHeader strong {\n  font-family: var(--title);\n  font-size: 0.94rem;\n  text-transform: capitalize;\n}\n\n.miniCalendarHeader div {\n  display: flex;\n  gap: 0.15rem;\n}\n\n.miniCalendarHeader button,\n.scheduleSelectorHeader button,\n.appointmentPanelHeader button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.8rem;\n  min-height: 1.8rem;\n  padding: 0;\n  color: #475467;\n  font: inherit;\n  background: transparent;\n  border: 0;\n  border-radius: 0.4rem;\n  cursor: pointer;\n}\n\n.miniCalendarHeader button:hover,\n.scheduleSelectorHeader button:hover,\n.appointmentPanelHeader button:hover {\n  color: #1d4ed8;\n  background: #eff4ff;\n}\n\n.miniCalendarGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0.16rem;\n  margin-top: 0.7rem;\n}\n\n.miniWeekDay,\n.miniDay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 1;\n  font-size: 0.75rem;\n  text-align: center;\n}\n\n.miniWeekDay {\n  color: #98a2b3;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.miniDay {\n  color: #344054;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.miniDay:hover {\n  background: #f2f4f7;\n}\n\n.miniDayOutside {\n  color: #b7bfca;\n}\n\n.miniDayToday {\n  color: #1d4ed8;\n  font-weight: 800;\n  border-color: #93b4ff;\n}\n\n.miniDaySelected {\n  color: #ffffff;\n  font-weight: 800;\n  background: var(--calendar-accent);\n  border-color: var(--calendar-accent);\n}\n\n.miniDaySelected:hover {\n  background: #1d4ed8;\n}\n\n.scheduleSelectorHeader h3 {\n  margin: 0;\n  font-family: var(--title);\n  font-size: 1rem;\n}\n\n.scheduleSelectorHeader button {\n  width: auto;\n  padding: 0 0.35rem;\n  color: #2563eb;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.scheduleList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  margin-top: 0.65rem;\n}\n\n.scheduleOption {\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr);\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  padding: 0.55rem 0.45rem;\n  border-radius: 0.55rem;\n  cursor: pointer;\n}\n\n.scheduleOption:hover {\n  background: #f6f8fb;\n}\n\n.scheduleOption input {\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n  accent-color: var(--calendar-accent);\n}\n\n.scheduleDot {\n  width: 0.65rem;\n  height: 0.65rem;\n  border-radius: 50%;\n  box-shadow: 0 0 0 0.18rem rgba(255, 255, 255, 0.85);\n}\n\n.scheduleOptionText {\n  min-width: 0;\n}\n\n.scheduleOptionText strong,\n.scheduleOptionText small {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.scheduleOptionText strong {\n  color: #344054;\n  font-size: 0.84rem;\n}\n\n.scheduleOptionText small {\n  margin-top: 0.08rem;\n  color: var(--calendar-muted);\n  font-size: 0.71rem;\n}\n\n.calendarSurface {\n  position: relative;\n  min-width: 0;\n  min-height: 49rem;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.gridWrapper {\n  position: relative;\n  height: 100%;\n  min-height: 49rem;\n}\n\n.timeGridViewport {\n  width: 100%;\n  max-height: 49rem;\n  overflow: auto;\n  background: #ffffff;\n}\n\n.timeGrid {\n  display: grid;\n  min-width: 48rem;\n  isolation: isolate;\n}\n\n.timeGridCorner,\n.dayHeader {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  min-height: 4.35rem;\n  background: rgba(255, 255, 255, 0.96);\n  border-bottom: 1px solid var(--calendar-border);\n  backdrop-filter: blur(0.6rem);\n}\n\n.timeGridCorner {\n  left: 0;\n  z-index: 7;\n}\n\n.dayHeader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 0.7rem 0.35rem;\n  color: #667085;\n  border-left: 1px solid #edf0f4;\n}\n\n.dayHeader span {\n  font-size: 0.77rem;\n  font-weight: 800;\n  text-transform: capitalize;\n}\n\n.dayHeader strong {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  color: #344054;\n  font-size: 1rem;\n  border-radius: 50%;\n}\n\n.dayHeaderToday strong {\n  color: #ffffff;\n  background: var(--calendar-accent);\n}\n\n.hourLabels {\n  position: sticky;\n  left: 0;\n  z-index: 4;\n  background: #ffffff;\n  border-right: 1px solid var(--calendar-border);\n}\n\n.hourLabels span {\n  position: absolute;\n  right: 0.55rem;\n  color: #98a2b3;\n  font-size: 0.7rem;\n  transform: translateY(-0.52em);\n}\n\n.dayColumn {\n  position: relative;\n  min-width: 0;\n  background:\n    linear-gradient(to bottom, transparent 50%, rgba(238, 241, 245, 0.55) 50%) 0 0 / 100% 32px,\n    #ffffff;\n  border-left: 1px solid #edf0f4;\n}\n\n.hourLine {\n  position: absolute;\n  right: 0;\n  left: 0;\n  height: 1px;\n  background: #e7ebf0;\n  pointer-events: none;\n}\n\n.currentTimeLine {\n  position: absolute;\n  right: 0;\n  left: 0;\n  z-index: 3;\n  height: 2px;\n  background: #e40032;\n  pointer-events: none;\n}\n\n.currentTimeLine::before {\n  position: absolute;\n  top: 50%;\n  left: -0.28rem;\n  width: 0.56rem;\n  height: 0.56rem;\n  background: #e40032;\n  border-radius: 50%;\n  content: \"\";\n  transform: translateY(-50%);\n}\n\n.timeEvent {\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-height: 1.75rem;\n  padding: 0.34rem 0.42rem 0.34rem 0.55rem;\n  overflow: hidden;\n  color: #1f2937;\n  text-align: left;\n  background: color-mix(in srgb, var(--event-color) 12%, white);\n  border: 0;\n  border-left: 0.24rem solid var(--event-color);\n  border-radius: 0.42rem;\n  box-shadow: 0 0.15rem 0.35rem rgba(16, 24, 40, 0.09);\n  cursor: pointer;\n}\n\n.timeEvent:hover,\n.timeEvent:focus-visible {\n  z-index: 4;\n  outline: 2px solid color-mix(in srgb, var(--event-color) 40%, white);\n  box-shadow: 0 0.35rem 0.85rem rgba(16, 24, 40, 0.16);\n}\n\n.timeEvent strong,\n.timeEvent span,\n.timeEvent small {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.timeEvent strong {\n  font-size: 0.78rem;\n  line-height: 1.22;\n}\n\n.timeEvent span,\n.timeEvent small {\n  margin-top: 0.1rem;\n  color: #536071;\n  font-size: 0.66rem;\n}\n\n.monthGrid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(7rem, 1fr));\n  min-width: 55rem;\n  min-height: 49rem;\n  overflow: auto;\n  background: #ffffff;\n}\n\n.monthWeekDay {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  padding: 0.75rem;\n  color: #667085;\n  font-size: 0.74rem;\n  font-weight: 800;\n  text-transform: capitalize;\n  background: rgba(255, 255, 255, 0.97);\n  border-bottom: 1px solid var(--calendar-border);\n  border-left: 1px solid #edf0f4;\n}\n\n.monthDay {\n  min-height: 7.4rem;\n  padding: 0.45rem;\n  background: #ffffff;\n  border-bottom: 1px solid #edf0f4;\n  border-left: 1px solid #edf0f4;\n}\n\n.monthDayOutside {\n  background: #fafbfd;\n}\n\n.monthDayOutside .monthDayNumber {\n  color: #b3bbc7;\n}\n\n.monthDayToday {\n  background: #f7faff;\n  box-shadow: inset 0 0 0 1px #bdd2ff;\n}\n\n.monthDayNumber {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  margin: 0 0 0.25rem auto;\n  color: #344054;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  background: transparent;\n  border: 0;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.monthDayNumber:hover,\n.monthDayToday .monthDayNumber {\n  color: #ffffff;\n  background: var(--calendar-accent);\n}\n\n.monthEvents {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.monthEvent {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0.35rem;\n  align-items: center;\n  width: 100%;\n  padding: 0.24rem 0.35rem;\n  color: #344054;\n  text-align: left;\n  background: color-mix(in srgb, var(--event-color) 10%, white);\n  border: 0;\n  border-left: 0.18rem solid var(--event-color);\n  border-radius: 0.3rem;\n  cursor: pointer;\n}\n\n.monthEvent:hover {\n  background: color-mix(in srgb, var(--event-color) 18%, white);\n}\n\n.monthEvent span {\n  color: #667085;\n  font-size: 0.64rem;\n}\n\n.monthEvent strong {\n  overflow: hidden;\n  font-size: 0.69rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.moreEvents {\n  padding-left: 0.35rem;\n  color: #2563eb;\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.inlineError {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin: 0.75rem;\n  padding: 0.7rem 0.85rem;\n  color: #912018;\n  background: #fff2f0;\n  border: 1px solid #f7c3bd;\n  border-radius: 0.65rem;\n}\n\n.inlineError button {\n  min-height: 1.9rem;\n  color: #912018;\n  border-color: #eaa49c;\n}\n\n.stateMessage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 34rem;\n  padding: 2rem;\n  color: #475467;\n  text-align: center;\n}\n\n.stateMessage h3 {\n  margin: 0.8rem 0 0.25rem;\n  color: #243142;\n  font-family: var(--title);\n  font-size: 1.25rem;\n}\n\n.stateMessage p {\n  max-width: 30rem;\n  margin: 0 0 1rem;\n  color: #667085;\n  text-align: center;\n}\n\n.stateIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.2rem;\n  height: 3.2rem;\n  color: #2563eb;\n  font-size: 1.65rem;\n  background: #eaf2ff;\n  border-radius: 1rem;\n}\n\n.loadingOverlay {\n  position: absolute;\n  inset: 0;\n  z-index: 8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  color: #344054;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(0.14rem);\n}\n\n.spinner {\n  width: 1.3rem;\n  height: 1.3rem;\n  border: 0.16rem solid #d9e4fb;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: calendarSpin 700ms linear infinite;\n}\n\n.emptyCalendarNotice {\n  position: absolute;\n  top: 5.2rem;\n  left: 50%;\n  z-index: 3;\n  padding: 0.45rem 0.75rem;\n  color: #667085;\n  font-size: 0.78rem;\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid #e4e9f0;\n  border-radius: 999px;\n  box-shadow: 0 0.2rem 0.7rem rgba(16, 24, 40, 0.07);\n  transform: translateX(-50%);\n}\n\n.appointmentPanel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 12;\n  width: min(23rem, 94%);\n  padding: 1.2rem;\n  overflow-y: auto;\n  background: rgba(255, 255, 255, 0.98);\n  border-left: 1px solid var(--calendar-border);\n  box-shadow: -1rem 0 2.5rem rgba(16, 24, 40, 0.13);\n  backdrop-filter: blur(0.75rem);\n}\n\n.appointmentPanelHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding-bottom: 0.8rem;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.appointmentPanelHeader h3 {\n  margin: 0.25rem 0 0;\n  color: #243142;\n  font-family: var(--title);\n  font-size: 1.25rem;\n}\n\n.appointmentPanelHeader button {\n  font-size: 1.35rem;\n}\n\n.statusBadge {\n  margin-top: 0.8rem;\n  color: #1d4ed8;\n  background: #eff4ff;\n  border-color: #c7d8ff;\n}\n\n.detailList {\n  margin: 0.4rem 0 0;\n}\n\n.detailList > div {\n  padding: 0.85rem 0;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.detailList dt {\n  margin-bottom: 0.28rem;\n  color: #667085;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.045em;\n  text-transform: uppercase;\n}\n\n.detailList dd {\n  margin: 0;\n  color: #344054;\n  font-size: 0.87rem;\n  line-height: 1.45;\n}\n\n.detailSchedules {\n  display: flex;\n  flex-direction: column;\n  gap: 0.38rem;\n}\n\n.detailSchedules span {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.detailSchedules i {\n  width: 0.65rem;\n  height: 0.65rem;\n  border-radius: 50%;\n}\n\n@keyframes calendarSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 1050px) {\n  .workspaceBody {\n    grid-template-columns: 14rem minmax(0, 1fr);\n  }\n\n  .sidebar {\n    padding: 0.75rem;\n  }\n\n  .periodTitle {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 820px) {\n  .workspaceHeader,\n  .toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .toolbarNavigation {\n    flex-wrap: wrap;\n  }\n\n  .periodTitle {\n    width: 100%;\n    margin: 0.35rem 0 0;\n  }\n\n  .viewSwitcher {\n    align-self: flex-start;\n  }\n\n  .workspaceBody {\n    display: block;\n  }\n\n  .sidebar {\n    display: grid;\n    grid-template-columns: minmax(14rem, 1fr) minmax(14rem, 1fr);\n    gap: 0.75rem;\n    border-right: 0;\n    border-bottom: 1px solid var(--calendar-border);\n  }\n\n  .scheduleSelector {\n    margin-top: 0;\n  }\n\n  .calendarSurface,\n  .gridWrapper {\n    min-height: 42rem;\n  }\n}\n\n@media (max-width: 560px) {\n  .workspace {\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0;\n  }\n\n  .workspaceHeader {\n    padding: 1rem;\n  }\n\n  .readOnlyBadge {\n    align-self: flex-start;\n  }\n\n  .sidebar {\n    display: block;\n  }\n\n  .scheduleSelector {\n    margin-top: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspace": `ScheduleCalendar_workspace__oOzDh`,
	"workspaceHeader": `ScheduleCalendar_workspaceHeader__bELDO`,
	"eyebrow": `ScheduleCalendar_eyebrow__uYDMg`,
	"detailEyebrow": `ScheduleCalendar_detailEyebrow__CSXj2`,
	"readOnlyBadge": `ScheduleCalendar_readOnlyBadge__MRWSM`,
	"statusBadge": `ScheduleCalendar_statusBadge__i4SvY`,
	"toolbar": `ScheduleCalendar_toolbar__53MBq`,
	"toolbarNavigation": `ScheduleCalendar_toolbarNavigation__TlPVF`,
	"viewSwitcher": `ScheduleCalendar_viewSwitcher__Vng6T`,
	"primaryCommand": `ScheduleCalendar_primaryCommand__JdF3O`,
	"iconCommand": `ScheduleCalendar_iconCommand__qk52l`,
	"viewButton": `ScheduleCalendar_viewButton__hDo-L`,
	"activeView": `ScheduleCalendar_activeView__hO5fC`,
	"inlineError": `ScheduleCalendar_inlineError__bkAn-`,
	"stateMessage": `ScheduleCalendar_stateMessage__9kgoo`,
	"periodTitle": `ScheduleCalendar_periodTitle__VEclP`,
	"workspaceBody": `ScheduleCalendar_workspaceBody__lDhHL`,
	"sidebar": `ScheduleCalendar_sidebar__VLvZj`,
	"miniCalendar": `ScheduleCalendar_miniCalendar__lO58e`,
	"scheduleSelector": `ScheduleCalendar_scheduleSelector__jEFEA`,
	"miniCalendarHeader": `ScheduleCalendar_miniCalendarHeader__oOFUi`,
	"scheduleSelectorHeader": `ScheduleCalendar_scheduleSelectorHeader__9bSVR`,
	"appointmentPanelHeader": `ScheduleCalendar_appointmentPanelHeader__NoNib`,
	"miniCalendarGrid": `ScheduleCalendar_miniCalendarGrid__nxyvA`,
	"miniWeekDay": `ScheduleCalendar_miniWeekDay__X0lZ7`,
	"miniDay": `ScheduleCalendar_miniDay__ORpDA`,
	"miniDayOutside": `ScheduleCalendar_miniDayOutside__zWvs6`,
	"miniDayToday": `ScheduleCalendar_miniDayToday__U7f04`,
	"miniDaySelected": `ScheduleCalendar_miniDaySelected__y9uc+`,
	"scheduleList": `ScheduleCalendar_scheduleList__P7NRv`,
	"scheduleOption": `ScheduleCalendar_scheduleOption__W9Uws`,
	"scheduleDot": `ScheduleCalendar_scheduleDot__yjyjl`,
	"scheduleOptionText": `ScheduleCalendar_scheduleOptionText__07wO9`,
	"calendarSurface": `ScheduleCalendar_calendarSurface__9RF-i`,
	"gridWrapper": `ScheduleCalendar_gridWrapper__zRQAE`,
	"timeGridViewport": `ScheduleCalendar_timeGridViewport__tBidz`,
	"timeGrid": `ScheduleCalendar_timeGrid__WV4NT`,
	"timeGridCorner": `ScheduleCalendar_timeGridCorner__wsP0R`,
	"dayHeader": `ScheduleCalendar_dayHeader__XEN48`,
	"dayHeaderToday": `ScheduleCalendar_dayHeaderToday__+7OQ3`,
	"hourLabels": `ScheduleCalendar_hourLabels__jP9d-`,
	"dayColumn": `ScheduleCalendar_dayColumn__P-jO7`,
	"hourLine": `ScheduleCalendar_hourLine__UGeAF`,
	"currentTimeLine": `ScheduleCalendar_currentTimeLine__qo1Cd`,
	"timeEvent": `ScheduleCalendar_timeEvent__a3D3f`,
	"monthGrid": `ScheduleCalendar_monthGrid__dY4SB`,
	"monthWeekDay": `ScheduleCalendar_monthWeekDay__kJA96`,
	"monthDay": `ScheduleCalendar_monthDay__NDqJs`,
	"monthDayOutside": `ScheduleCalendar_monthDayOutside__F57fX`,
	"monthDayNumber": `ScheduleCalendar_monthDayNumber__MCUf4`,
	"monthDayToday": `ScheduleCalendar_monthDayToday__AnOry`,
	"monthEvents": `ScheduleCalendar_monthEvents__1gAdz`,
	"monthEvent": `ScheduleCalendar_monthEvent__lxF7s`,
	"moreEvents": `ScheduleCalendar_moreEvents__bT+KX`,
	"stateIcon": `ScheduleCalendar_stateIcon__bKDj9`,
	"loadingOverlay": `ScheduleCalendar_loadingOverlay__klHSi`,
	"spinner": `ScheduleCalendar_spinner__96gQG`,
	"calendarSpin": `ScheduleCalendar_calendarSpin__FghWp`,
	"emptyCalendarNotice": `ScheduleCalendar_emptyCalendarNotice__4dGdZ`,
	"appointmentPanel": `ScheduleCalendar_appointmentPanel__e-olh`,
	"detailList": `ScheduleCalendar_detailList__CY2dK`,
	"detailSchedules": `ScheduleCalendar_detailSchedules__lwnvw`
};
export default ___CSS_LOADER_EXPORT___;
